<template>
  <v-dialog v-model="show" width="600">
    <v-card class="mt-2">
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">仕入INV No の追加</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          id="save"
          :disabled="!buyerInvNos || buyerInvNos.length === 0"
          @click="save"
          small
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <v-btn @click="show = false" small>{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid" onsubmit="return false">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                @keydown="(e) => checkIfEnter(e, 'appendBuyerInvNo()')"
                required
                label="仕入INV No"
                clearable
                :rules="[
                  (v) =>
                    !v ||
                    (!!v && v.length <= 20) ||
                    '仕入INV Noを20文字以下にしてください',
                ]"
                v-model.trim="buyerInvNo"
              />
            </v-flex>
            <div class="chip-wrap">
              <v-chip
                @input="closeBuyerInvNos(item)"
                v-for="item in buyerInvNos"
                :key="item"
                class="ma-2"
                close
                color="orange"
                outline
              >
                {{ item }}
              </v-chip>
            </div>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["bl"],
  data() {
    return {
      show: false,
      valid: false,
      buyerInvNo: null,
      buyerInvNos: [],
    };
  },
  methods: {
    popup() {
      this.show = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      //this.resolve(this.buyerInvNo);
      this.$emit("appendBuyerInvNo", this.buyerInvNos);
      this.buyerInvNo = null;
      this.buyerInvNos = [];
      this.show = false;
    },
    checkIfEnter(e, funcName) {
      console.log(e);
      if ("Enter" === e.key) {
        console.log("this." + funcName);
        localStorage.setItem("checkIfEnter", "this." + funcName);
        eval("this." + funcName);
      }
      if ("appendBuyerInvNo()" === funcName && "Tab" === e.key) {
        document.getElementById("save").focus();
        e.preventDefault();
      }
    },
    appendBuyerInvNo() {
      if (!this.buyerInvNo) {
        return;
      }
      if (
        this.buyerInvNos.indexOf(this.buyerInvNo) !== -1 ||
        this.bl.buyerInvNo.indexOf(this.buyerInvNo) !== -1
      ) {
        this.$message("", "仕入INV No重複");
        return;
      }
      this.buyerInvNos.push(this.buyerInvNo);
      this.buyerInvNo = null;
    },
    closeBuyerInvNos(item) {
      const index = this.buyerInvNos.indexOf(item);
      if (index > -1) {
        this.buyerInvNos.splice(index, 1);
      }
    },
  },
};
</script>
